// extracted by mini-css-extract-plugin
export default {"container":"ClassAcademy_container__uhIJV","table":"ClassAcademy_table__9ScAU","statusContainer":"ClassAcademy_statusContainer__mFs7c"};